import React, { useEffect, useState } from "react";
import styles from "./BannerAdmin.module.css";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { AxiosInstance } from "../../../../../../axios";
import ConfirmationPopup from "../ConfirmationPopup/ConfirmationPopup";
import moment from "moment";
import Loader from "../../../../Loader";
import toast from "react-hot-toast";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { ImageUrlPrefix } from "../../../../../../labels";

function ViewBannerAdminInfo() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedBannerId, setSelectedBannerId] = useState(null);
  const [currentImage, setCurrentImage] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [existFolderData, setExistFolderData] = useState([]);
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id not available in session storage");
  }
  useEffect(() => {
    const folderPayloadImage = {
      is_admin: 1,
      page: "",
      page_size: "",
    };
    AxiosInstance.post("/api/gallery/banner/list", folderPayloadImage)
      .then((res) => {
        const imageFolderOptions = res.data?.data || [];
        const displayOption1 = imageFolderOptions
          .filter((item) => item.display_option === 1)
          .sort((a, b) => new Date(b.created_dt) - new Date(a.created_dt)); // Sort descending
        const displayOption0 = imageFolderOptions
          .filter((item) => item.display_option === 0)
          .sort((a, b) => new Date(a.created_dt) - new Date(b.created_dt)); // Sort ascending
        const sortedItems = [...displayOption1, ...displayOption0];
        setExistFolderData(sortedItems); // Update state with sorted data
      })
      .catch((error) => {
        return error;
      });
  }, [isLoading]);
  const handleImageClick = (src) => {
    setCurrentImage(src);
    setShowPopup(true);
  };
  const handleClosePopup = () => {
    setShowPopup(false);
    setCurrentImage(null);
  };
  const handleCheckboxChange = (id) => {
    setSelectedBannerId((prevId) => (prevId === id ? null : id));
  };
  const handleDeleteBanner = () => {
    if (selectedBannerId !== null) {
      setShowConfirmation(true);
    }
  };
  const confirmDeleteBanner = async () => {
    if (selectedBannerId !== null) {
      try {
        let filteredObj = existFolderData.filter(
          (item) => item.id === selectedBannerId
        )[0];
        let payload = {
          id: selectedBannerId,
          display_option: 1,
          is_deleted: 1,
          start_date: moment(filteredObj.start_date).format("YYYY-MM-DD"),
          end_date: moment(filteredObj.end_date).format("YYYY-MM-DD"),
          created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
          created_by: userid || "",
          banner_path: filteredObj.banner_path,
          original_banner_path: filteredObj.original_banner_path,
        };
        setIsLoading(true);
        await AxiosInstance.post(`/api/gallery/banner/add`, payload)
          .then((res) => {
            if (res.status) {
              toast.success(res.data.message || "Banner added successfully!");
              setIsLoading(false);
              navigate("/ViewBannerAdmin");
            } else {
              setIsLoading(false);
              toast.error(res.data.message || "Failed to add banner.");
            }
          })
          .catch((error) => {
            console.error("Error while adding banner:", error);
            setIsLoading(false);
            toast.error(
              "An error occurred while adding the banner. Please try again."
            );
          })
          .finally(() => {
            setSelectedBannerId(null);
            setShowConfirmation(false);
          });
      } catch (error) {
        console.error("Error deleting the image:", error);
      }
    } else {
      console.warn("No image selected for deletion.");
    }
  };

  const cancelDeleteBanner = () => {
    setShowConfirmation(false);
  };

  const handleEditBanner = () => {
    if (selectedBannerId) {
      navigate(`/EditBanner/${selectedBannerId}`);
    }
  };

  const handleAddBanner = () => {
    navigate(`/AddBanner`);
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      <Loader />
    </div>
  ) : (
    <div className={`${styles.GalleryInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">Slides</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul className="List-Button">
            {/* <li className="ListBtnItems">
              <Link
                onClick={handleBackHome}
                to="javascript:void(0)"
                className="secondaryButton"
              >
                Back to Home
              </Link>
            </li> */}
            <li className="ListBtnItems">
              <Button
                onClick={handleAddBanner}
                className={`primaryButton text-center border-0 ${
                  selectedBannerId ? `${styles.editDisable}` : ""
                }`}
                variant="primary"
              >
                Add New Slide
              </Button>
            </li>

            <li className="ListBtnItems">
              <Button
                onClick={handleEditBanner}
                className={`primaryButton text-center border-0 ${
                  selectedBannerId ? "" : `${styles.editDisable}`
                }`}
                variant="primary"
              >
                Edit Slide
              </Button>
            </li>
            <li className="ListBtnItems">
              <Link
                className={`primaryButton text-center border-0 ${
                  selectedBannerId ? "" : `${styles.editDisable}`
                }`}
                onClick={handleDeleteBanner}
              >
                Delete Slide
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {existFolderData.length > 0 ? (
        <>
          <div className={`${styles.gridContainer} row  pt-2`}>
            {existFolderData
              .filter((banner) => new Date(banner.end_date) >= new Date())
              .map((banner) => (
                <div key={banner.id} className="col-md-3 col-12 mb-4">
                  <div className={`${styles.banner_card} card`}>
                    <>
                      <LazyLoadImage
                        src={`${ImageUrlPrefix}/${banner.banner_path}`}
                        alt={banner.original_banner_path || "Image"}
                        className={`${styles.image} card-img-top`}
                        onClick={() =>
                          handleImageClick(
                            `${ImageUrlPrefix}/${banner.banner_path}`
                          )
                        }
                        style={{
                          filter:
                            banner.display_option === 0 ? "blur(3px)" : "none",
                        }}
                      />
                      <input
                        type="checkbox"
                        className={styles.checkbox}
                        checked={selectedBannerId === banner.id}
                        onChange={() => handleCheckboxChange(banner.id)}
                        style={{
                          position: "absolute",
                          top: "10px",
                          transform: "scale(1.5)",
                          right: "10px",
                          cursor: "pointer",
                        }}
                      />
                    </>
                  </div>
                </div>
              ))}
          </div>
        </>
      ) : (
        <>
          <p style={{ textAlign: "center" }}>No Records to display</p>
        </>
      )}

      {/* Popup for the image */}
      {showPopup && (
        <div className={styles.modal}>
          <span className={styles.close} onClick={handleClosePopup}>
            &times;
          </span>
          <img className={styles.modalImage} src={currentImage} alt="Zoomed" />
        </div>
      )}

      {/* Render the confirmation popup */}
      {showConfirmation && (
        <ConfirmationPopup
          open={showConfirmation}
          title="Delete Slide"
          message="Are you sure you want to delete this slide?"
          onConfirm={confirmDeleteBanner}
          onCancel={cancelDeleteBanner}
        />
      )}
    </div>
  );
}
export default ViewBannerAdminInfo;
